import { render, staticRenderFns } from "./createMain.vue?vue&type=template&id=34853abe&scoped=true"
import script from "./createMain.vue?vue&type=script&lang=js"
export * from "./createMain.vue?vue&type=script&lang=js"
import style0 from "./createMain.vue?vue&type=style&index=0&id=34853abe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34853abe",
  null
  
)

export default component.exports